import { onMounted, onUnmounted, ref } from 'vue';
import {
    type Breakpoint,
    getSnapshot,
    isBiggerBreakpoint,
    isBiggerOrEqualBreakpoint,
    isBreakpoint,
    isUnderBreakpoint,
    onBreakpointChange,
    startResizeTracking,
    stopResizeTracking,
} from '@/utils/mediaQueriesCore.ts';
import { useLegacyLayoutBreakpoints } from '@/utils/legacyBreakpointsAdapter.ts';

export default function useMediaQueries() {
    const snapshot = getSnapshot();
    const currentBreakpoint = ref<Breakpoint>(snapshot.currentBreakpoint);
    const width = ref(snapshot.width);
    const height = ref(snapshot.height);
    let unsubscribe: (() => void) | null = null;

    const is = (targetBreakpoint: string): boolean => {
        return isBreakpoint(currentBreakpoint.value, targetBreakpoint);
    };

    const isUnder = (targetBreakpoint: string): boolean => {
        return isUnderBreakpoint(currentBreakpoint.value, targetBreakpoint);
    };

    const isBigger = (targetBreakpoint: string): boolean => {
        return isBiggerBreakpoint(currentBreakpoint.value, targetBreakpoint);
    };

    const isBiggerOrEqual = (targetBreakpoint: string): boolean => {
        return isBiggerOrEqualBreakpoint(currentBreakpoint.value, targetBreakpoint);
    };

    onMounted(() => {
        unsubscribe = onBreakpointChange((nextSnapshot) => {
            currentBreakpoint.value = nextSnapshot.currentBreakpoint;
            width.value = nextSnapshot.width;
            height.value = nextSnapshot.height;
        });
        startResizeTracking();
    });

    onUnmounted(() => {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = null;
        }

        stopResizeTracking();
    });

    const {
        isLandscape,
        xsLayout,
        smLayout,
        mdLayout,
        lgLayout,
        xlLayout,
        oneXlLayout,
        xxlLayout,
        phoneLayout,
    } = useLegacyLayoutBreakpoints(width, height);

    return {
        currentBreakpoint,
        is,
        isUnder,
        isBigger,
        isBiggerOrEqual,
        isLandscape,
        xsLayout,
        smLayout,
        mdLayout,
        lgLayout,
        xlLayout,
        oneXlLayout,
        xxlLayout,
        phoneLayout,
    };
}
